import { NodeType } from '@/api/nodes/mutations/directory/create-directory-mutation'
import { LucideIcon } from 'lucide-react'
import { ElementType, ReactNode } from 'react'

export enum NodeActionScope {
    SELECTED_MULTIPLE = 'SELECTED_MULTIPLE',
    SELECTED_SINGLE = 'SELECTED_SINGLE',
    PREVIEW = 'PREVIEW',
}

export enum NodeAction {
    MOVE = 'MOVE',
    DELETE = 'DELETE',
    DOWNLOAD = 'DOWNLOAD',
    FAVORITE = 'FAVORITE',
    RENAME = 'RENAME',
}

export type INodeAction = {
    icon: LucideIcon | ElementType
    label: string
    call: () => void
    className?: string

    /**
     * Define which scopes this action is available in
     * If undefined, available in all scopes
     */
    availableForScopes?: NodeActionScope[]

    /**
     * Define which node types this action applies to
     * If undefined, applies to all types
     */
    applicableForTypes?: NodeType[]

    /**
     * Super users can access this action in these scopes,
     * even if not in availableForScopes. If set to undefined, it doesn't override.
     */
    superUserScopeOverride?: NodeActionScope[]
}

export type IUseActionReturnType = {
    action: INodeAction
    nodes: ReactNode
}
